import { useCallback, useState } from "react";

// useEffect内で用いる際、無限ループが発生するため、useCallbackで囲っている。
// 参考リンク
// https://blog.uhy.ooo/entry/2021-02-23/usecallback-custom-hooks/

export const useLoadingIndicator = (initialLoadingState: boolean = false) => {
  const [isLoading, setIsLoading] = useState(initialLoadingState);
  const changeLoadingIndicator = useCallback(() => {
    setIsLoading((i) => !i);
  }, []);

  const startLoading = useCallback(() => {
    setIsLoading(true);
  }, []);

  const stopLoading = useCallback(() => {
    setIsLoading(false);
  }, []);

  return [isLoading, changeLoadingIndicator, startLoading, stopLoading] as const;
};
